// @flow @format
export const sleep = (milliseconds: number): Promise<void> =>
	new Promise(resolve => window.setTimeout(resolve, milliseconds));



// WEBPACK FOOTER //
// ./src/lib/downloader/util.js